import { useChunkTranslation } from "../hooks";

const SuspenseChunkTranslation = ({
  children,
  chunkFile,
  fallback,
  options
}) => {
  const done = useChunkTranslation(chunkFile, options());
  return /*#__PURE__*/React.createElement(React.Fragment, null, done ? children : fallback);
};

export { SuspenseChunkTranslation };